<template>
	<div class="graph-builder-page">
		<div class="page-head">
			<div class="text-h6" style="color: #12e049">GRAPH BUILDER</div>
		</div>
		<GraphTreeBuilder />
	</div>
</template>

<script setup lang="ts">
	definePageMeta({
		colorMode: 'dark',
		hideRightDrawer: true,
	});
</script>

<style scoped>
	/* Fill the layout's .content-area (which already accounts for the
	   header and its own padding) instead of doing 100vh math here. */
	.graph-builder-page {
		height: 100%;
		display: flex;
		flex-direction: column;
		background: black;
		overflow: hidden;
	}

	.page-head {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
		flex: 0 0 auto;
	}

	/* The builder fills whatever the page head leaves over. */
	.graph-builder-page > :deep(.graph-tree-builder) {
		flex: 1 1 auto;
		min-height: 0;
	}
</style>
